import { render, staticRenderFns } from "./PuzzleConfirmer.vue?vue&type=template&id=7cae2d68&"
import script from "./PuzzleConfirmer.vue?vue&type=script&lang=js&"
export * from "./PuzzleConfirmer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports